// extracted by mini-css-extract-plugin
module.exports = {"formWidget":"FormWidget_formWidget__1oswr"};